export const columns = (setModalRol, openModalAdd, setModalConfirm, modalConfirm) => [
    {
        id: "name",
        name: "Name",
        minWidth: "240px",
        cell: (row) => (
            <div className="flex items-center gap-3">
                <div className="flex flex-col">
                    <span className="text-sm font-semibold text-cs-dark leading-tight">
                        {row.name}
                    </span>
                    {row.slug && (
                        <span className="text-[9px] text-cs-muted uppercase tracking-wide">
                            {row.slug}
                        </span>
                    )}
                </div>
            </div>
        ),
    },
    {
        id: "description",
        name: "Description",
        minWidth: "260px",
        cell: (row) => (
            <div className="flex flex-col gap-0.5">
                <span className="text-[10px] text-cs-muted line-clamp-2">
                    {row.description || "No description provided for this role."}
                </span>
            </div>
        ),
    },
    {
        id: "models",
        name: "Models & permissions",
        minWidth: "220px",
        cell: (row) => {
            const totalModels = row.models_total || 0;

            return (
                <div className="flex items-center gap-2 text-[10px]">
                    <div className="flex items-center gap-1 px-2 py-1 rounded-full bg-cs-primary-soft text-cs-primary-dark border border-cs-border">
                        <span className="material-symbols-outlined text-[14px]">
                            view_list
                        </span>
                        <span className="font-medium">
                            {totalModels} Models
                        </span>
                    </div>

                    <button
                        type="button"
                        onClick={() =>
                            setModalRol({
                                show: true,
                                rol: row,
                                title: row.name,
                            })
                        }
                        className="
                            inline-flex items-center gap-1.5
                            px-2 py-1 rounded-lg
                            bg-cs-bg-alt
                            text-cs-muted
                            hover:bg-cs-primary
                            hover:text-white
                            border border-cs-border
                            hover:border-cs-primary-hover
                            text-[9px]
                            transition-all
                        "
                        title="Show models & permissions"
                    >
                        <span className="material-symbols-outlined text-[14px]">
                            shield_person
                        </span>
                        <span>View details</span>
                    </button>
                </div>
            );
        },
    },
    {
        id: "users_count",
        name: "Associated users",
        minWidth: "150px",
        cell: (row) => {
            const usersCount = Number(row.users_count || 0);

            return (
                <div className="flex items-center gap-2 text-[10px]">
                    <div className={`px-2 py-1 rounded-full border ${usersCount > 0 ? "bg-amber-50 text-amber-700 border-amber-200" : "bg-emerald-50 text-emerald-700 border-emerald-200"}`}>
                        {usersCount} {usersCount === 1 ? "user" : "users"}
                    </div>
                    {usersCount > 0 && (
                        <span className="text-cs-muted">
                            Cannot be deleted
                        </span>
                    )}
                </div>
            );
        },
    },
    {
        id: "actions",
        name: "",
        right: true,
        minWidth: "90px",
        cell: (row) => {
            const canDelete = !!row.can?.delete;
            const canDeletePermission = !!row.can?.deletePermission;
            const usersCount = Number(row.users_count || 0);
            const isDeleteDisabled = canDeletePermission && !canDelete;

            return (
                <div className="flex items-center justify-end gap-2">
                    <button
                        type="button"
                        onClick={() => openModalAdd(row)}
                        className="
                            p-1.5 rounded-lg
                            text-cs-muted
                            hover:bg-cs-primary-soft
                            hover:text-cs-primary
                            transition-colors
                        "
                        title="Edit"
                    >
                        <span className="material-symbols-outlined text-[18px]">
                            edit
                        </span>
                    </button>

                    {canDeletePermission && (
                        <button
                            type="button"
                            disabled={isDeleteDisabled}
                            onClick={() =>
                                setModalConfirm({
                                    ...modalConfirm,
                                    show: true,
                                    id: row.id,
                                    title: "Delete Role",
                                    textLoad: "Deleting role...",
                                    textButton: "Delete",
                                    text: "Are you sure you want to delete this role?",
                                })
                            }
                            className={`
                                p-1.5 rounded-lg transition-colors
                                ${isDeleteDisabled
                                    ? "text-slate-300 bg-slate-100 cursor-not-allowed"
                                    : "text-cs-danger hover:bg-cs-danger/5"
                                }
                            `}
                            title={isDeleteDisabled
                                ? `This role cannot be deleted because it has ${usersCount} associated ${usersCount === 1 ? "user" : "users"}.`
                                : "Delete"
                            }
                        >
                            <span className="material-symbols-outlined text-[18px]">
                                delete
                            </span>
                        </button>
                    )}
                </div>
            );
        },
    },
];
